import React, { useState, useEffect } from 'react'
import { HTTP } from '../../api/resources';
import Select from 'react-select'

export default function BlockSponsors({team, blockedSponsors, allSponsors, project, hasEditPermission = true}) {
  const [editSponsors, setEditSponsors] = useState([])
  const [saving, setSaving] = useState(false)
  const [editing, setEditing] = useState(false);
  const [selectedSponsor, setSelectedSponsor] = useState(null);
  const [selectOptions, setSelectOptions] = useState(null);
  const [unsavedIds, setUnsavedIds] = useState([])

  useEffect(() => {
    initializeComponent()
  }, []);

  const initializeComponent = async () => {
    await updateCurrentSponsors()

    setUnsavedIds([])
  }

  const updateCurrentSponsors = async () => {
    setEditSponsors(blockedSponsors);
    let updatedOptions = _.differenceWith(allSponsors, blockedSponsors, (a, b) => a.id == b.id)
    updatedOptions = _.orderBy(updatedOptions, ['name'], ['asc'])
    setSelectOptions(updatedOptions)

    return true
  }

  const save = () => {
    setSaving(true);
    const data = { blocked_sponsors: editSponsors }


    HTTP.patch(`/pro/blocked_sponsors/${project.id}?request_action=update`, data).then(response => {
        setUnsavedIds([])
        setSaving(false);
        setEditSponsors(response.data);
        Alert.show('notice', 'Updated successfully!');
      }).catch(e => {
        setSaving(false);
        Alert.show('error', 'Could not update! Try again or refresh.');
      })
  }

  const cleanList = () => {
    if (unsavedIds.length > 0) {
    for (let num = 0; unsavedIds.length > num; num++) {
      let unsaved = unsavedIds[num]
      for (let x = 0; editSponsors.length > x; x++) {
        if (unsaved == editSponsors [x].id) {
          editSponsors.splice(x, 1)
        }
      }
    }
    }
  }

  const clearComp = () => {
    setEditing(false)
    if(unsavedIds.length > 0)  Alert.show('notice', `${unsavedIds.length} unsaved ${team.donor_title.toLowerCase()} has been removed from the list`)
    cleanList()
    setUnsavedIds([])
    initializeSelectOptions()
  }

  const addSponsor = () => {
    if (selectedSponsor) {
      unsavedIds.push(selectedSponsor.id)
      let index = _.findIndex(editSponsors, {id: selectedSponsor.id})

      if (index < 0) {
        selectedSponsor.not_saved = true
        setEditSponsors(state => [...state, selectedSponsor])
      }
    }
    setSelectedSponsor(null)
    removeSelectOption(selectedSponsor)
  }

  const addSelectOption = (option) => {
    let updatedOptions = [...selectOptions, option]
    updatedOptions = _.orderBy(updatedOptions, ['name'], ['asc'])
    setSelectOptions(updatedOptions)
  }

  const removeSelectOption = (option) => {
    let updatedOptions = _.reject(selectOptions, (a) => a.id == option.id)
    updatedOptions = _.orderBy(updatedOptions, ['name'], ['asc'])
    setSelectOptions(updatedOptions)
  }

  const removeSponsor = (sponsor) => {
    if (!sponsor.not_saved) {
      if (window.confirm(`Are you sure you want to unblock this ${sponsor.name}?`))
        removeMembers(sponsor)
      else {
        return
      }
    }
    const updatedSponsors = _.reject(editSponsors, (g) => g.id == sponsor.id);
    setEditSponsors(updatedSponsors)
    addSelectOption(sponsor)
    removeArray(sponsor.id)
  }

  const removeMembers = async (sponsor) => {
    setSaving(true)
    HTTP.patch(`/pro/blocked_sponsors/${project.id}?request_action=delete&delete_id=${sponsor.id}`).then(response => {
      setSaving(false);
      Alert.show('notice', 'Update successful');
    }).catch(e => {
      setSaving(false);
      Alert.show('error', 'Could not update! Try again or refresh.');
    })
  }

  const removeArray = (id) => {
    if (id < 0) return undefined
    for (let i = 0; i < unsavedIds.length; i++) {
      let arrValue = unsavedIds[i]
      if (arrValue == id) {
        unsavedIds.splice(i, 1)
      }
    }
  }

  return (
    <div id="user-group-form" className="card">
      <div className="card-header flex-header">
        <div>
          <h4 className="card-title">Block {team.donor_title}</h4>
          <small>Block individual {team.donor_title.toLowerCase()} from making public posts to this {team.project_title.toLowerCase()}</small>
        </div>
        <div>
          {editing && (
            <div>
              <button onClick={clearComp} name="button" className="btn btn-outline-danger mr-1">
                Close
              </button>
              <button onClick={save} name="button" className="btn btn-primary">
                {saving && (<i className="fa fa-spinner-third fa-spin mr-2"></i>)}
                Save
              </button>
            </div>
          )}
          {!editing && hasEditPermission && (
            <button onClick={() => setEditing(true)} className="btn btn-primary"> Edit {team.donor_title}</button>
          )}
        </div>
      </div>

      {editing && hasEditPermission && (
        <div className="form-group">
          <label>Add {team.donor_title}</label>
          <div className="input-group">
            <Select
              className="form-control select-groups"
              classNamePrefix="select-groups"
              onChange={(sponsor) =>
                setSelectedSponsor(sponsor)
              }
              options={selectOptions}
              getOptionLabel={sponsor => `${sponsor.name}` }
              getOptionValue={sponsor => sponsor.id}
              value={selectedSponsor}
            />
            <div className="input-group-append">
              <button onClick={() => addSponsor()} className="btn btn-primary">Add</button>
            </div>
          </div>
        </div>
      )}

      <div className="list-group list-group-flush">
        {editSponsors.map((sponsor) => (
          <div key={sponsor.id} id={`sponsor-table-${sponsor.id}`} className="list-group-item">
            <div className='list-group-item-body'>
              <div className='list-group-item-body-main mb-2'>
                <span className="mr-1">{sponsor.name}</span>
              </div>
            </div>
            {editing && (<div className='list-group-item-actions d-none-mobile'>
              { sponsor.not_saved && (<span className="badge badge-sm badge-warning badge-pill mr-2">Not Saved</span>)}

              <button
                onClick={() => removeSponsor(sponsor)}
                className="btn btn-sm btn-danger">Remove</button>
            </div>
            )}

          </div>)
        )}
      </div>
    </div>
  )
}
